import React from 'react';
import { CheckIcon, SparkleIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
import { Ornament } from './Ornament';
import { PriceTag } from './PriceTag';
const frictionPoints = ['No more hours searching for the next class idea.', 'No more disconnected routines.', 'No more repeating the same lower-body sequence because planning time ran out.', 'No more wondering what progression should come next.', 'No more beginning every week from an empty page.'];
const included = ['6 Complete Instructor Volumes', '150 Ready-to-Teach Barre Classes', '100% Visual Core Teaching Material', 'Beginner Barre', 'Glutes & Thighs', 'Lower-Body Barre', 'Core', 'Balance', 'Stability', 'Arms', 'Upper Body', 'Posture', 'Cardio Barre', 'Full-Body Barre', 'Progressive Programming', 'Mini-Band Classes', 'Barre Ball Classes', 'Pulse & Hold', 'Slow-Control Barre', 'Class Timelines', 'Coaching Cues', 'Corrections', 'Modifications', 'Progressions', '5 Professional Bonus Guides', 'Immediate Digital Access', 'PDF Format'];
export function FinalCTA() {
  return <section className="bg-inverse px-4 py-20 text-inverse-foreground sm:py-28" data-id="element-116" data-mp="2m2ubzaxeg79h">
      <div className="mx-auto max-w-4xl" data-id="element-117" data-mp="2m4x729desql2">
        <div className="text-center" data-id="element-118" data-mp="2r277ek2c6mno">
          <h2 className="text-3xl font-semibold leading-tight text-inverse-foreground sm:text-4xl" data-id="element-119" data-mp="2r38j8qr6fd6g">
            Next Week You Can Keep Planning Every Barre Class From Scratch…
            <br data-id="element-120" data-mp="301as1sh5ja4a" />
            <span className="italic text-accent-soft" data-id="element-121" data-mp="3010wzqh92crq">
              Or you can open a complete system and already know where to
              start.
            </span>
          </h2>
          <Ornament className="mt-6" data-id="element-122" data-mp="39r3rxw7xm0sp" />
          <div className="mx-auto mt-10 max-w-2xl rounded-xl border border-inverse-foreground/10 bg-inverse-foreground/[0.04] p-7 text-left" data-id="element-123" data-mp="39u9htdodx6ph">
            <ul className="space-y-3" data-id="element-124" data-mp="3isbrehm6p7od">
              {frictionPoints.map(point => <li key={point} className="flex gap-3 text-sm leading-6 text-inverse-foreground/80" data-id="element-125" data-mp="1jntrruhhzzyc">
                  <SparkleIcon size={16} className="mt-1 shrink-0 text-accent" aria-hidden="true" data-id="element-126" data-mp="1en5r0h3gw4qx" />
                  {point}
                </li>)}
            </ul>
          </div>
          <p className="mx-auto mt-10 max-w-3xl font-display text-3xl font-semibold text-accent-soft" data-id="element-127" data-mp="22djjg8pys5m1">
            Barre Instructor Ready does not replace your knowledge as an
            instructor.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-inverse-foreground/70" data-id="element-128" data-mp="2beq4mv3k64lm">
            It gives you a system for using that knowledge with greater
            structure, variety and efficiency.
          </p>
        </div>

        <div className="mt-14 rounded-2xl border border-accent/50 bg-inverse-raised p-7 shadow-elevated sm:p-11" data-id="element-129" data-mp="d06dkf27e9it">
          <h3 className="text-center text-3xl font-semibold text-inverse-foreground" data-id="element-130" data-mp="2vpxbkktaqeh">
            Everything Included
          </h3>
          <Ornament className="mt-4" data-id="element-131" data-mp="6x1s04ijm1tj" />
          <ul className="mt-8 grid gap-x-8 md:grid-cols-2" data-id="element-132" data-mp="3pbkd5afrf18w">
            {included.map(item => <li key={item} className="flex items-baseline gap-3 border-b border-accent/15 py-3" data-id="element-133" data-mp="3uankj1j7pjk1">
                <CheckIcon size={15} className="shrink-0 translate-y-0.5 text-accent" aria-hidden="true" data-id="element-134" data-mp="3fclhcsg3f03b" />
                <span className="text-sm font-medium leading-6 text-inverse-foreground/90" data-id="element-135" data-mp="36dgitm4j76r5">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mt-6 text-center text-xs font-medium uppercase tracking-[0.1em] text-inverse-foreground/60" data-id="element-136" data-mp="14llc7kx4tsfs">
            Immediate Access · Complete Digital PDF Bundle
          </p>

          <div className="mt-10 rounded-xl border border-accent/40 bg-primary-strong px-6 py-9 text-center" data-id="element-137" data-mp="35nb1itc0ugb3">
            <p className="font-display text-3xl font-semibold text-primary-foreground" data-id="element-138" data-mp="30nyg8d0stham">
              <ProductName script accentClassName="text-accent-soft" data-id="element-139" data-mp="2vp3lqdtgy4ao" />
            </p>
            <p className="mx-auto mt-4 max-w-xl font-display text-xl italic leading-8 text-primary-foreground" data-id="element-140" data-mp="2vr7xtj1iu9m1">
              The Complete 6-in-1 Visual Teaching System for Barre Instructors
            </p>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-primary-foreground/80" data-id="element-141" data-mp="2hxyvu3fwkqdj">
              150 Ready-to-Teach Classes • 6 Complete Volumes • 100% Visual
              Core Material • 5 Professional Bonus Guides
            </p>
            <p className="mt-5 text-xs font-bold tracking-[0.2em] text-accent-soft" data-id="element-142" data-mp="2813w5h7w8jxo">
              SEE IT. CHOOSE IT. TEACH IT.
            </p>
          </div>

          <div className="mt-10 flex flex-col items-center text-center" data-id="element-143" data-mp="1yzcucngh4x93">
            <PriceTag tone="dark" data-id="element-144" data-mp="1z17cju0d2b9h" />
            <CheckoutButton variant="rose" className="mt-7" data-id="element-145" data-mp="ehlhtff6i964">
              GET BARRE INSTRUCTOR READY NOW
            </CheckoutButton>
            <p className="mt-5 text-xs text-inverse-foreground/60" data-id="element-146" data-mp="jelmpn0al5vn">
              Immediate Access · Complete Digital PDF Bundle
            </p>
          </div>
        </div>
      </div>
    </section>;
}